let STRIPE_API_KEY
if (PRODUCTION) {
  STRIPE_API_KEY =
    'pk_live_VwdHAQvH3fPhRgeHq1zDGspj'
} else {
  STRIPE_API_KEY =
    'pk_live_VwdHAQvH3fPhRgeHq1zDGspj'
}

export {
  STRIPE_API_KEY
}
